export default [
  {
    title: "داشبورد",
    icon: "HomeIcon",
    route: "dashboard",
  },

  {
    title: "کاربران",
    icon: "UsersIcon",
    route: "users",
  },
  {
    title: "ترم ها",
    icon: "TrelloIcon",
    route: "semesters",
  },
  {
    title: "دوره ها",
    icon: "ClipboardIcon",
    route: "courses",
  },
  {
    title: "جلسه ها",
    icon: "BookOpenIcon",
    route: "sessions",
  },
  {
    title: "تمرین ها",
    icon: "FileTextIcon",
    route: "exercises",
  },
  {
    title: "رویداد ها",
    icon: "RefreshCcwIcon",
    route: "events",
  },
  {
    title: "فاکتور ها",
    icon: "ClipboardIcon",
    route: "invoices",
  },
  {
    title: "جریمه ها",
    icon: "InfoIcon",
    route: "penalties",
  },
  {
    title: "تراکنش ها",
    icon: "TrelloIcon",
    route: "transactions",
  },
  {
    title: "گزارش فعالیت",
    icon: "TrelloIcon",
    route: "audit-logs",
  },
  {
    title: "سوالات کاربران",
    icon: "MessageCircleIcon",
    route: "comments",
  },
  {
    title: "پرسش و پاسخ",
    icon: "TwitchIcon",
    route: "faqs",
  },
  {
    title: "دستگاه ها",
    icon: "AirplayIcon",
    route: "devices",
  },
  {
    title: "دوره های آموزشی",
    icon: "BookOpenIcon",
    route: "shop",
  },
  {
    title: "ارسال پیام",
    icon: "TwitchIcon",
    route: "notifications",
  },
];
